import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu ,
 Nav , NavItem, Dropdown , DropdownToggle,Label,FormGroup, Input,InputGroup} from 'reactstrap';
 import { TabContent, TabPane,  NavLink, CardText, Row, Col } from 'reactstrap';

import classnames from 'classnames';

import ReactTable from "react-table";
import "react-table/react-table.css";


import * as actions from '../../actions/movimientocaclientes';
// import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import moment from 'moment';
import Select from 'react-select';
import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ProductosModal from "./ProductosModal";

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);



   
class EmbarqueModal extends React.Component
{
     constructor(props)
    {
        super(props)

        this.state = {
            compra: {
                id:0,
                cliente_id:0,
                movimiento_id:1,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:'0.00',
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                rfc_banco_beneficiario:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:2,

                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"Abono",
            naturaleza:'Abono',

             /**variables para el modal de productos*/
            modal_productos:false,
            renglon:[],
            indice:null,
            productos:[],

        
           
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);

        this.toggle_productos= this.toggle_productos.bind(this); 
        this.producto_modal= this.producto_modal.bind(this); 
        this.eliminar_producto= this.eliminar_producto.bind(this);  

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
                 
    }

     toggle_productos(index="nuevo",renglon=[]){
        let {compra} = this.state;
        let self = this;
        console.log('renglon modal-->',renglon);
        console.log('Indice--->',index);
          if(parseInt(compra.cliente_id)==0)
          {
             swal("Oops..", "Seleccione un Cliente");

          }else{
            api().get('/tipo_cambio_venta')
            .then(function(response)
            {

              self.setState({
                indice:index,
                modal_productos : !self.state.modal_productos, 
                renglon:renglon, 
                tc:parseFloat(response.data.venta)       
            })            
            });
          
            

          }
          
    } 

     calcular_totales(productos,compra){
      
      let importe=0;
      let descuento=0;
      let subtotal=0;
      let cargos=0;
      let ieps=0;
      let impuesto=0;
      let total=0;

      for (var i = productos.length - 1; i >= 0; i--) {
        importe+=parseFloat( productos[i].precio_total);
        descuento+=parseFloat( productos[i].cantidad_descuento);
        impuesto+=parseFloat( productos[i].cantidad_impuesto1)+parseFloat( productos[i].cantidad_impuesto2);
        ieps+=parseFloat( productos[i].ieps_total);

      }
      subtotal=importe - descuento;
      total=subtotal+cargos+ieps+impuesto;

     


      compra.importe=this.trunc(importe,2);
      compra.descuento=this.trunc(descuento,2);
      compra.subtotal=this.trunc(subtotal,2);
      compra.ieps=this.trunc(ieps,2);
      compra.impuestos=this.trunc(impuesto,2);
      compra.total=this.trunc(total,2);

      





      this.setState({
            compra : compra,
            productos : productos,
            productos_importe:importe,
            productos_descuento:descuento,
            productos_ieps:ieps,
            productos_impuestos:impuesto,

        });

    }

        trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}

    producto_modal(renglon,accion){
      var productos = this.state.productos;
      var compra = this.state.compra;
      var i=parseInt(this.state.indice);
      if(accion=="save"){
       productos.unshift(renglon);
      }else{
        productos[i]=renglon;

      }
      this.calcular_totales(productos,compra);

    }

    eliminar_producto(index){
      var productos = this.state.productos;
      var compra = this.state.compra;

      swal({
        title: 'Estas seguro?',
        text: "Se eliminara  el producto de la lista!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
             productos.splice(index, 1);
             this.calcular_totales(productos,compra);

        }
      })
    }

    handleClose (event) {
        console.log('evento--->',event)
         
        let {compra} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla="";
        let bandera_proveedor=true;

        
         switch (name) {
            case "factura_codigo":                  
                  campo = "factura_id";
                  tabla="/busqueda_facturas_cliente/"+compra.cliente_id;
                  if(parseInt(compra.cliente_id)==0)
                    bandera_proveedor=false;

                  break;
            case "proveedor_codigo":                                  
                  campo = "cliente_id";
                  tabla="/busqueda_cliente";                   
                  break;
            case "movimiento_codigo":                 
                  campo = "movimiento_id";
                  tabla="/busqueda_movimiento";
                  break;      
        }
        let self =this;
        if(value!=""&&bandera_proveedor){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                         self.retorno(retorno,campo,vaciar,value);                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }                            
                   
                }

            });
        }else{
           if(bandera_proveedor==false){
            swal("Oops..", "Selecciona un Cliente");

          }
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        console.log('renglon---->',objeto);
        let {compra} = this.state;
        let self =this;
        
         if(vacio==1){
          console.log('vaciar')
          codigo=valor;
          descripcion="";
          compra[campo] =0;
         }

         console.log('descripcion--->',descripcion);

         switch (campo) {
            case "cliente_id":
                if(vacio==1){
                  console.log('vaciar')
                  compra[campo] =0;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:valor,
                        proveedor_descripcion:'',
                        saldo_proveedor:'$0.00',
                        modal:false,         
                    }) 
                 }else{
                  compra[campo] = objeto.value?objeto.value:objeto.id;
                  self.setState({
                        
                        compra : compra,           
                        proveedor_codigo:objeto.value?objeto.value:objeto.id,
                        proveedor_descripcion:objeto.label?objeto.label:objeto.nombre,
                        saldo_proveedor:objeto.saldo,
                        codigo_precio:parseInt(objeto.codigo_precio)!=0?parseInt(objeto.codigo_precio):1,
                        modal:false,         
                    }) 

                 }  
                  break;
            case "factura_id":
                  if(vacio==1){
                    console.log('vaciar')
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.cantidad = '0.00';
                      compra.impuestos = '0.00';
                      compra.total = '0.00';
                     self.setState({
                        factura:[],
                        compra : compra,           
                        factura_codigo:valor,
                        factura_descripcion:'',
                        saldo_documento:'$0.00',
                        saldo_original:'$0.00',
                        subtotal_documento:'$0.00',
                        impuesto_documento:'$0.00',
                        modal:false,         
                    }) 
                   }else{
                     codigo=objeto.factura;
                      descripcion=objeto.concepto;
                      campo_codigo="factura_codigo";
                      campo_descripcion="factura_descripcion"; 
                      compra[campo] = objeto.value?objeto.value:objeto.id;
                      compra.cantidad = objeto.subtotal_numero;
                      compra.impuestos = objeto.impuesto_numero;
                      compra.total = objeto.saldo_numero;
                      // if(parseInt(objeto.tipo_doc)==2){
                        compra.rfc_ordenante='N/A';
                        compra.nombre_banco_extranjero='N/A';
                        compra.rfc_banco_beneficiario='N/A';
                        compra.cuenta_beneficiario='N/A';
                        compra.tipo_cadena_pago='N/A';
                        compra.correo='N/A';
                      // }
                       self.setState({
                        factura:objeto,
                        compra : compra,           
                        [campo_codigo]:codigo,
                        [campo_descripcion]:descripcion,
                        saldo_documento:objeto.saldo,
                        saldo_original:objeto.total,
                        subtotal_documento:objeto.subtotal,
                        impuesto_documento:objeto.impuesto,
                        modal:false,         
                  })
                   }
                 
                  break;
            case "movimiento_id":
                  if(vacio==1){
                    codigo=valor;
                    descripcion="";
                    compra[campo] =0;
                    compra.tipo =0;
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:valor,
                        movimiento_descripcion:'',
                        naturaleza:'',
                        modal:false,         
                    }) 
                   }  else{
                    compra[campo] = objeto.value?objeto.value:objeto.id;  
                    compra.tipo = objeto.tipo;                               
                    self.setState({
                        compra : compra,           
                        movimiento_codigo:objeto.codigo,
                        movimiento_descripcion:objeto.label,
                        naturaleza:objeto.tipo_nombre,
                        modal:false,         
                    }) 

                   }
                  
                  break;    
        }
        
    }
    toggle_modal(index=0,catalogo="",campo=""){
    if(campo=='factura_id'&&parseInt(this.state.compra.cliente_id)==0){
        swal("Oops..", "Selecciona un Cliente");

    }else{
        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }  

        
    }   

    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            compra: {
                ...this.state.compra,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }



    componentDidMount()
    {

       api().get('/sat/formas_pago/2')
      .then(function(response)
      {
        if(response.status === 200)
        {
          self.setState({
            formas : response.data
          });
        }
      });
         
        let id = this.props.id;
        let self = this;
              
        if(id > 0 && id != self.state.compra.id)
        {

            api().get(`movimientocac/${id}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        compra: response.data.movimientoca,
                        action: 'update',
                        factura:response.data.factura,
                        proveedor_codigo:response.data.cliente.codigo,
                        proveedor_descripcion:response.data.cliente.nombre,
                        saldo_proveedor:response.data.cliente.saldo,
                        factura_codigo:response.data.factura.factura,
                        factura_descripcion:response.data.factura.concepto,
                        movimiento_codigo:response.data.movimiento.codigo,
                        movimiento_descripcion:response.data.movimiento.nombre,
                        naturaleza:response.data.movimiento.naturaleza,
                        subtotal_documento:response.data.factura.subtotal,
                        impuesto_documento:response.data.factura.impuesto,
                        saldo_documento:response.data.factura.saldo,
                        saldo_original:response.data.factura.total,
                        productos:response.data.productos
                    });

                }

            });
        }
        else if(id == null && self.state.compra.id)
        {   
            console.log('Reset Modal');
            self.resetModal();
        }
    }

   

    resetModal(){
        this.setState({
           compra: {
                id:0,
                cliente_id:0,
                movimiento_id:1,
                factura_id:0,
                importe:'0.00',
                descuento:'0.00',
                subtotal:'0.00',
                ieps:'0.00',
                impuestos:'0.00',
                total:'0.00',
                fecha: moment().format('Y-MM-DD'),
                concepto:'',
                referencia:'',
                tipo:1,
                forma_pago:1,
                rfc_ordenante:'',
                nombre_banco_extranjero:'',
                rfc_banco_beneficiario:'',
                cuenta_beneficiario:'',
                tipo_cadena_pago:'',
                correo:'',
                certificado_pago:'',
                cadena_pago:'',
                sello_pago:'',
                tipo_movimiento_id:2,
                             
            },
            factura:[],
            subtotal_documento:"$0.00",
            impuesto_documento:"$0.00",
            saldo_documento:"0.00",
            saldo_proveedor:"$0.00",
            saldo_original:"0.00",
            action: 'save',
            activeTab: '1',          
            /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
            /*variables para los campos de busqueda de codigos*/
            proveedor_codigo:'',
            proveedor_descripcion:"",
            factura_codigo:'',
            factura_descripcion:"",
            movimiento_codigo:'',
            movimiento_descripcion:"",
            naturaleza:'',
             /**variables para el modal de productos*/
            modal_productos:false,
            renglon:[],
            indice:null,
            productos:[],
        });
        
    }
    handleInputChange(event) {
        let {compra} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        compra[name] = value;
        if(name=='cantidad'||name=='impuestos')
        {
          compra.total=parseFloat(compra.cantidad)+parseFloat(compra.impuestos);
        }
     
        this.setState({
            compra : compra
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     if(key!="lista"){
                       objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     }
                        
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

   handleSubmit(evt){
        evt.preventDefault();
        let {compra,factura,productos} = this.state;
        if(parseInt(compra.cancelado)==1){
          swal("Oops..", "Movimiento Cancelado ","warning");
          return false;
        } 
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;        
        
            let check = ['referencia','concepto','fecha','rfc_ordenante','nombre_banco_extranjero','rfc_banco_beneficiario','cuenta_beneficiario','tipo_cadena_pago','correo'];
            // if(parseInt(factura.tipo_doc)==2){
              check = ['referencia','concepto','fecha'];
            // }
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
            check = [
            'cliente_id',
            'movimiento_id',
            ];
            if(save)
            for(let i in check) {

            let key = check[i];

            let value = compra[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

        var patt = new RegExp("[a-zA-Z0-9]?[a-zA-Z0-9]{11}[a-zA-Z0-9]$", "i");         
        // if(parseInt(factura.tipo_doc)!=2){   
        //     if(compra.rfc_ordenante.length>11&&compra.rfc_ordenante.search(patt)==0){

        //       if(compra.rfc_banco_beneficiario.length>11&&compra.rfc_banco_beneficiario.search(patt)==0){

        //       }else{
        //         save=false;
        //         dato='RFC Banco Beneficiario';
        //       }

        //     }else{
        //       save=false;
        //       dato='RFC Ordenante';
        //     }
        // }
        
          //   if(save && parseInt(compra.tipo)==1 ){
          //     console.log("compra--->",parseFloat(compra.cantidad));
          //     console.log('factura--->',parseFloat(factura.subtotal_numero));
          //     if( parseFloat(compra.cantidad)>parseFloat(factura.subtotal_numero))
          //     {
          //       dato= "Cantidad es mayor al del Documento a afectar";
          //       save=false;
          //     }
          //     if(parseFloat(compra.impuestos)>parseFloat(factura.impuesto_numero))
          //     {
          //       dato= "Impuesto es mayor al del Documento a afectar";
          //       save=false;
          //     }
          //      if(parseFloat(compra.total)>parseFloat(factura.saldo_numero))
          //     {
          //       dato= "total es mayor al del Documento a afectar";
          //       save=false;
          //     }
             
          // }
          let lista=[];
            if(save){

              
              if(productos.length === 0) {
                save=false;
                mensaje=false;

                  swal("Oops..", "Por favor Verificar la lista de los productos ");

              }else{

                lista=productos;
              } 
            }

            compra.lista=lista;

        compra=this.objeto_mayusculas(compra);
        
        console.log('productos----->',productos)
        if(save   ){

             api().post(`/validacion_movimientocac`, compra)
              .then(function(response)
              {  
                 let validacion=response.data.validacion;
                  let encontrado=response.data.encontrado[0];
              if(validacion||(parseInt(encontrado.id)===parseInt(compra.id) )){
        
                    self.props[action](compra, (data) => {
                      self.props.alerta({
                        mensaje:"Nota de Abono /Credito se Guardado correctamente!",
                        tipo:"success",
                        creacion:moment().format('Y-MM-DD H:m:s'),
                      });
                      self.resetModal();
                      self.props.cerrar();
                   
                });

                    }else{
                    swal("Oops..", "El Codigo ya existe");
                }
            });

               
            
        }else{
          
            swal("Oops..", "Por favor Verificar el Campo "+dato );

        }
    }

    render() {
       let {compra,action}=this.state;
         let editar=true;
         if(action=='update')
          editar=false;
 
        return(
            <div className="view">
             <form onSubmit={this.handleSubmit} >
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Movimiento Notas de Abono/Credito</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                          <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"  >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>
                          
                          <div className="row mt-3 form_cliente">
                         <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-3"> 
                                        <div className="form-group">
                                            <label className="d-block">Movimiento:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="movimiento_codigo"
                                            value={this.state.movimiento_codigo}
                                            onChange={ this.ChangeCode}
                                            onBlur={this.handleClose}
                                            className="input_button"
                                            disabled
                                           
                                            />
                                            
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="d-block">Movimiento: {this.state.movimiento_descripcion}</label>
                                    <label className="d-block">Naturaleza: {this.state.naturaleza}</label>
                                </div>
                                </div>

                            </div>
                                          
                         </div>
                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Referencia *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="referencia"
                                    maxLength={25}
                                    value={compra.referencia} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>Concepto *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="concepto"
                                    maxLength={75}
                                    value={compra.concepto} 
                                    onChange={this.handleInputChange}
                                    required  />
                            </FormGroup>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha *:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={compra.fecha || ''}
                                    onChange={this.handleInputChange}
                                   required
                                />
                            </div>
                        </div>
                        </div>
                         <div className="row form_cliente">
                         <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Cliente *:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="proveedor_codigo"
                                            value={this.state.proveedor_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                            disabled={!editar}
                                           required
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.proveedor_descripcion}</label>
                                </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Factura:</label>
                                            <Input
                                            placeholder=""
                                            name="factura_codigo"
                                            value={this.state.factura_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                             className="input_button"
                                             disabled={!editar}
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(32,"Facturas","factura_id") } } disabled={!editar}>...</Button>
                                        </div>
                                    </div>
                                
                                <div className="col-md-7 pt-4">
                                    <label className="">{this.state.factura_descripcion}</label>
                                </div>
                                </div>

                            </div>               
                         </div>

                         




                        
                         

                          

                          <div className="row mt-3 form_cliente">
                                    <div className="col-md-12 text-right">
                                      
                                        <Button color="success" className="mb-2"  onClick={()=>this.toggle_productos(null,[])}>
                                    &nbsp;Agregar
                                       </Button>
                                    </div>

                                    <div className="col-md-12">    
                                                <ReactTable
                                                  getTrProps={(state, rowInfo, column) => {                                  
                                                      if(rowInfo === undefined){                                          
                                                              return{
                                                              }
                                                            }else{
                                                               return{
                                                                onDoubleClick: ()=>this.toggle_productos(rowInfo.index,rowInfo.original)
                                                            }                                   
                                                        }
                                                  }}
                                                  data      = {this.state.productos}
                                                  className = "-striped -highlight"
                                                  columns   = {[

                                                    {
                                                        Header: 'Controles',
                                                        filterable: false,
                                                        sortable: false,
                                                        maxWidth:150,
                                                        Cell: (row) =>
                                                        {
                                                            return(
                                                                <div className="text-right">
                                                                <Button
                                                                     color="primary" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.toggle_productos(row.index,row.original)}>
                                                                        <IconEdit />
                                                                    </Button>{' '}
                                                                    <Button
                                                                     color="danger" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.eliminar_producto(row.index)}>
                                                                        X
                                                                    </Button>{' '}
                                                                     
                                                                </div>
                                                            )
                                                        }
                                                    },
                                                   
                                                    {Header: 'Clave', accessor: 'codigo',maxWidth:100,minWidth:100 , style: { 'textAlign': 'center'}},
                                                    {Header: 'Codigo Art', accessor: 'codigo_proveedor',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Descripcion', accessor: 'nombre' ,minWidth:500, style: { 'textAlign': 'center'}},                    
                                                    {Header: 'Unidades', accessor: 'cantidad',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Costo', accessor: 'costo',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Precio', accessor: 'precio',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Unid * Precio', accessor: 'precio_total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Desc. %', accessor: 'descuento',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Descuento', accessor: 'cantidad_descuento',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Importe', accessor: 'importe',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'IEPS', accessor: 'ieps_total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp1 %', accessor: 'impuesto1',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp 1', accessor: 'cantidad_impuesto1',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp2 %', accessor: 'impuesto2',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Imp 2', accessor: 'cantidad_impuesto2',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                    {Header: 'Total', accessor: 'total',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},                                                  
                                                  ]}
                                                  filterable 
                                                  pageSizeOptions= {[5]}
                                                  defaultPageSize={5} 
                                                  defaultFilterMethod={filterCaseInsensitive}
                                                />
                                    </div>
                                    

                          </div>

                          <div className="row form_cliente">
                         <div className="col-md-4">
                            <div className="row">
                            </div>               
                         </div>
                         <div className="col-md-8 ">
                            <div className="row">
                               <div className="col-md-1">
                                 <div className="row">
                                 </div>               
                               </div>
                               <div className="col-md-7 mt-5">
                                  <div className="row">
                                  <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Subtotal Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.subtotal_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Impuestos Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.impuesto_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Documento: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_documento}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Original: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_original}</Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>Saldo Cliente: </Label></h5>
                                        </FormGroup>
                                    </div>
                                    <div className="col-6 text-left">
                                        <FormGroup>
                                            <h5><Label>{this.state.saldo_proveedor}</Label></h5>
                                        </FormGroup>
                                    </div>
                                  </div>               
                               </div>
                               <div className="col-md-4">
                                  <div className="row mt-4">
                                   <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Importe: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.importe}</Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Descuento: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.descuento}</Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Subtotal: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.subtotal}</Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>IEPS: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.ieps}</Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Impuestos: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.impuestos}</Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Total: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+compra.total}</Label></h5>
                                                </FormGroup>
                                            </div>
                                  </div>               
                               </div> 
                            </div>               
                         </div>                                          
                        </div>

                          <br/>
                          <br/>
                          <br/>
                          <br/>

                          <div className="row">
                          <div className='col-5'>
                          <div className="row">
                          <div className="col-12"> 
                                <div className="form-group">
                                    <label className>Forma de Pago *:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="forma_pago"
                                        options={this.state.formas}
                                        value={parseInt(compra.forma_pago) || ""}
                                       onChange={ (select) => { this.handleSelectChange(select, 'forma_pago') } }
                                        clearable={false}

                                    />
                                </div>
                            </div>
                            <div className="col-12">
                            <FormGroup>
                                <Label>RFC Emisor de Cuenta Ordenante *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc_ordenante"
                                    maxLength={13}
                                    value={compra.rfc_ordenante}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Nombre Banco Ordenante Extranjero *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="nombre_banco_extranjero"
                                    maxLength={75}
                                    value={compra.nombre_banco_extranjero}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>

                        <div className="col-12">
                            <FormGroup>
                                <Label>RFC del Banco de la Cta Benef. *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="rfc_banco_beneficiario"
                                    maxLength={13}
                                    value={compra.rfc_banco_beneficiario}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Cuenta del Beneficiario *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="cuenta_beneficiario"
                                    maxLength={13}
                                    value={compra.cuenta_beneficiario}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Tipo de Cadena de Pago *</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="tipo_cadena_pago"
                                    maxLength={20}
                                    value={compra.tipo_cadena_pago}
                                    onChange={ this.handleInputChange}
                                    required
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-12">
                            <FormGroup>
                                <Label>Correo</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="correo"
                                    maxLength={95}
                                    value={compra.correo}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>

                          </div>

                          </div>
                          <div className='col-7'>
                          <div className="row">
                          <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Certificado que ampara el pago</label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="certificado_pago"
                                      value={compra.certificado_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange}
                                      readOnly
                                      />
                                    
                                </div>
                            </div>
                          <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Cadena Original del comprobante del pago </label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="cadena_pago"
                                      value={compra.cadena_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange}
                                      readOnly
                                      />
                                    
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className>Sello digital que se asocie al pago </label>
                                    <Input
                                      rows={5}                                                        
                                      type="textarea"
                                      name="sello_pago"
                                      value={compra.sello_pago} 
                                      maxLength={150}
                                      onChange={ this.handleInputChange}
                                      readOnly
                                      />
                                    
                                </div>
                            </div>

                          </div>
                          </div>

                          </div>

                           <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientocaclientes.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"   >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>

                         

                    
                        
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <br/>

                        </CardBlock>
                    </Card>
                </div>
               </form>


                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    cliente_id={this.state.compra.cliente_id}
                />
                }

                {
                   this.state.modal_productos&&
                <ProductosModal 
                 open={this.state.modal_productos} 
                 toggle={this.toggle_productos} 
                 title={"Producto"} 
                 renglon={this.state.renglon}
                 retorno={this.producto_modal}
                 id={this.state.indice}
                 precios_id={this.state.codigo_precio}
                 tc={this.state.tc}                   
                />
                }
                
            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocaclientes : state.movimientocaclientes,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(EmbarqueModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscaclientes/nota.js